module.exports = __webpack_public_path__ + "static/media/pro@2x.61892f3a.png";